import { combineReducers } from "@reduxjs/toolkit";
import { reducer as appReducer } from "../appSlice";
import { reducer as loginReducer } from "../../components/PublicLayout/LoginPage/loginActions";
import { reducer as registrationReducer } from "../../components/PublicLayout/RegistrationPage/registrationActions";
import { reducer as forgotPasswordReducer } from "../../components/PublicLayout/ForgotPasswordPage/forgotPasswordActions";
import { reducer as documentManagementReducer } from "../../features/admin/GestioneDocumentiPage/gestisciDocumentiSlice";
import { reducer as practiceManagementReducer } from "../../features/admin/GestisciPratichePage/GestisciPraticheSlice";
import { reducer as gestisciStudioReducer } from "../../features/business/GestisciStudioPage/gestisciStudioSlice";
import { reducer as singleDocumentReducer } from "../../features/common/SingleDocumentPage/singleDocumentSlice";
import { reducer as categoriesSliceReducer } from "../categoriesSlice";
import { reducer as enumsSliceReducer } from "../enumsSlice";
import { userStudioApi } from "../../features/api/user/associaStudioApi";
import { serviziApi } from "../../features/api/admin/ServiziApi";
import { magicViewApi } from "../../features/api/admin/magicViewApi";
import { adminStudioApi } from "../../features/api/admin/gestisciStudioApi";
import { managementNewsApi } from "../../features/api/admin/gestioneNewsApi";
import { adminNewsApi } from "../../features/api/admin/newsApi";
import { userNewsApi } from "../../features/api/user/newsApi";
import { userPracticeServicesApi } from "../../features/api/user/servicesStudioApi";
import { userProfileApi } from "../../features/api/user/modificaProfiloApi";
import { adminUsersApi } from "../../features/api/admin/gestisciUtentiApi";
import { adminDashboardApi } from "../../features/api/admin/dashboardApi";
import { adminDocumentsApi } from "../../features/api/admin/gestisciDocumentiApi";
import { adminPracticesApi } from "../../features/api/admin/gestisciPraticheApi";
import { adminCategoriesApi } from "../../features/api/admin/categoriesApi";
import { adminCommercialistiApi } from "../../features/api/admin/gestisciCommercialistiApi";
import { otherServicesApi } from "../../features/api/admin/altriServiziApi";
import { userDocumentsApi } from "../../features/api/user/gestisciDocumentiApi";
import { userCategoriesApi } from "../../features/api/user/categoriesApi";
import { userDashboardApi } from "../../features/api/user/userDashboardApi";
import { userPracticesApi } from "../../features/api/user/gestisciPraticheApi";
import { userOtherServicesApi } from "../../features/api/user/altriServiziApi";
import { notificheApi } from "../../features/api/admin/notificheApi";
import { userAssistenteSmartApi } from "../../features/api/user/assistenteSmartApi";
import { assistenteSmartApi } from "../../features/api/admin/assistenteSmartApi";
import { userAccount } from "../../features/api/user/userAccount";
import { userCalendarApi } from "../../features/api/user/calendarApi";
import { adminAuth } from "../../features/api/admin/authApi";
import { adminCompany } from "../../features/api/admin/adminCompany";
import { chatbotApi } from "../../features/api/admin/chatbotApi";
import { adminFolderApi } from "../../features/api/admin/adminFolders";
import { aiPromptApi } from "../../features/api/admin/aiPromptApi";
import { rolesApi } from "../../features/api/admin/rolesApi";
import { userFolders } from "../../features/api/user/userFolders";
import { notificationUserApi } from "../../features/api/user/notificationUserApi";
import { notificationAdminApi } from "../../features/api/admin/notificationAdmin";

const reducers = {
  app: appReducer,
  login: loginReducer,
  categories: categoriesSliceReducer,
  enums: enumsSliceReducer,
  registration: registrationReducer,
  forgotPassword: forgotPasswordReducer,
  docManagementSlice: documentManagementReducer,
  practiceManagementSlice: practiceManagementReducer,
  gestisciStudioSlice: gestisciStudioReducer,
  singleDocument: singleDocumentReducer,

  //USER API
  [userDashboardApi.reducerPath]: userDashboardApi.reducer,
  [userOtherServicesApi.reducerPath]: userOtherServicesApi.reducer,
  [userDocumentsApi.reducerPath]: userDocumentsApi.reducer,
  [userNewsApi.reducerPath]: userNewsApi.reducer,
  [userPracticesApi.reducerPath]: userPracticesApi.reducer,
  [userPracticeServicesApi.reducerPath]: userPracticeServicesApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,
  [userCategoriesApi.reducerPath]: userCategoriesApi.reducer,
  [userAssistenteSmartApi.reducerPath]: userAssistenteSmartApi.reducer,
  [userAccount.reducerPath]: userAccount.reducer,
  [userCalendarApi.reducerPath]: userCalendarApi.reducer,
  [userFolders.reducerPath]: userFolders.reducer,
  [notificationUserApi.reducerPath]: notificationUserApi.reducer,

  //ADMIN API
  [adminDashboardApi.reducerPath]: adminDashboardApi.reducer,
  [otherServicesApi.reducerPath]: otherServicesApi.reducer,
  [serviziApi.reducerPath]: serviziApi.reducer,
  [adminCommercialistiApi.reducerPath]: adminCommercialistiApi.reducer,
  [adminUsersApi.reducerPath]: adminUsersApi.reducer,
  [adminDocumentsApi.reducerPath]: adminDocumentsApi.reducer,
  [adminPracticesApi.reducerPath]: adminPracticesApi.reducer,
  [adminCategoriesApi.reducerPath]: adminCategoriesApi.reducer,
  [notificheApi.reducerPath]: notificheApi.reducer,
  [adminAuth.reducerPath]: adminAuth.reducer,
  [managementNewsApi.reducerPath]: managementNewsApi.reducer,
  [userStudioApi.reducerPath]: userStudioApi.reducer,
  [adminNewsApi.reducerPath]: adminNewsApi.reducer,
  [assistenteSmartApi.reducerPath]: assistenteSmartApi.reducer,
  [magicViewApi.reducerPath]: magicViewApi.reducer,
  [adminStudioApi.reducerPath]: adminStudioApi.reducer,
  [adminCompany.reducerPath]: adminCompany.reducer,
  [chatbotApi.reducerPath]: chatbotApi.reducer,
  [adminFolderApi.reducerPath]: adminFolderApi.reducer,
  [aiPromptApi.reducerPath]: aiPromptApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [notificationAdminApi.reducerPath]: notificationAdminApi.reducer
};

const rootReducer = combineReducers({
  ...reducers,
});

export default rootReducer;
